import { LocalesEnum } from '../enums/LocalesEnum';

export const createMapFBD = (rawName: LocalesEnum) => ({ attributes }: { attributes: string }) => {
  const attributesObj = JSON.parse(attributes);
  return {
    template: attributesObj?.['1022']?.[rawName] || [],
    linkages: attributesObj?.['1023']?.[rawName] || [],
  }
}
